import { EntitlementResult, NotEntitledJustification } from '../types';
export function getResult(entitlementResults: EntitlementResult[]): EntitlementResult {
  let hasExpired = false;
  for (const entitlementResult of entitlementResults) {
    if (entitlementResult.isEntitled) {
      return entitlementResult;
    }

    if (entitlementResult.justification === NotEntitledJustification.BUNDLE_EXPIRED) {
      hasExpired = true;
    }
  }

  return {
    isEntitled: false,
    justification: hasExpired ? NotEntitledJustification.BUNDLE_EXPIRED : NotEntitledJustification.MISSING_FEATURE,
  };
}

export function shouldContinue(entitlementResults: EntitlementResult[]): boolean {
  return entitlementResults.every(({ isEntitled }) => !isEntitled);
}
